import { render, staticRenderFns } from "./Treinamentos.vue?vue&type=template&id=768f8275&"
import script from "./Treinamentos.vue?vue&type=script&lang=js&"
export * from "./Treinamentos.vue?vue&type=script&lang=js&"
import style0 from "./Treinamentos.vue?vue&type=style&index=0&id=768f8275&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports